import React, { Component, Fragment } from "react";
import { Row, Col, Container, Image } from "react-bootstrap";

import styles from "./Landing.module.scss";

import Agrinol from "../../assets/png/Agrinol.png";
import PlantVideo from "../../assets/mp4/PlantVideo.mp4";

export default class Landing extends Component {
  render() {
    return (
      <section id={styles.Landing}>
        <div className={styles.videoContainer}>
          <video
            className={styles.plantVideo}
            controls={false}
            preload="auto"
            autoPlay
            loop
            muted
            playsInline
          >
            <source src={PlantVideo} type="video/mp4"></source>
          </video>
        </div>
        <Container className={styles.landingContainer} fluid>
          <Row>
            <Col>
              <a href={`.`}>
                <Image src={Agrinol} alt="Agrinol" id={styles.AgrinolLogo} />
              </a>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <p className={styles.containerText} id={styles.Text1}>
                lifestyle <br></br> essentials <br></br> made better.
              </p>
            </Col>

            <Col md={6}>
              <p className={styles.containerText} id={styles.Text2}>
                Revolutionary carbon-capture technology that brings life back to
                your everyday.
              </p>
              <div className={styles.hl}></div>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}
